const Logo = () => (
    <svg xmlns='http://www.w3.org/2000/svg' width='100%' height='76' className='max-h-full max-w-auto' fill='none' viewBox='0 0 259 76'>
        <path
            fill='currentColor'
            fillRule='evenodd'
            d='m91.657 28.646-5.185 19.998-5.184-19.998H68.973v40h9.074V48.644l5.835 20.002h5.183l5.833-20.002v20.002h9.075l-.002-40H91.657ZM249.765 29.197v19.905l-9.175-19.905h-9.177v19.905l-9.176-19.905h-9.175v39.814h9.175V51.757l9.176 17.254h9.177V51.757l9.175 17.254h9.175V29.197h-9.175ZM45.277 0 28.675 41.14c-1.678 3.953-2.656 7.88-2.656 10.617v23.889l19.258-46.449 19.26 46.449V51.757c0-2.655-1.104-6.634-2.657-10.616L45.277 0Z'
            clipRule='evenodd'
        />
        <path
            fill='currentColor'
            fillRule='evenodd'
            d='M45.276 49.102c-5.495 0-9.962 4.47-9.962 9.94 0 5.53 4.467 9.969 9.962 9.969a9.954 9.954 0 0 0 9.963-9.97c0-5.468-4.466-9.938-9.962-9.938ZM190.532 0l-16.603 41.14c-1.678 3.953-2.658 7.88-2.658 10.617v23.889l19.261-46.449 19.257 46.449V51.757c0-2.655-1.103-6.634-2.655-10.616L190.532 0Z'
            clipRule='evenodd'
        />
        <path
            fill='currentColor'
            fillRule='evenodd'
            d='M190.974 48.646c-5.519 0-10.001 4.49-10.001 9.985a9.995 9.995 0 0 0 10.001 10.015 9.995 9.995 0 0 0 9.999-10.015c0-5.494-4.482-9.985-9.999-9.985ZM116.286 55.945h4.938v-20.31h-4.938v20.31Zm4.785-27.299h-14.098v40h9.313V63.02h4.785c3.824 0 8.902 0 8.894-7.108-.006-4.914.008-19.703.008-20.32.004-6.946-5.052-6.946-8.902-6.946ZM150.625 48.226l-5.304-20.15h-12.598V68.38h9.284V48.226l5.966 20.153h5.305l5.968-20.153V68.38h9.284V28.077h-12.598l-5.307 20.15ZM16.886 28.075l-6.63 16.122V28.075H.973v40.302h9.297l-.014-17.462h3.978v17.462h9.283V48.226c0-3.185-1.728-4.029-3.979-4.029l6.631-16.122h-9.283Z'
            clipRule='evenodd'
        />
    </svg>
)

export { Logo }
